// extracted by mini-css-extract-plugin
export default {"container":"modal_container__-9a2p","modal":"modal_modal__ldg0F","title":"modal_title__YDzC8","text":"modal_text__Ciesm","number":"modal_number__IRpym","price":"modal_price__ktc4a"};